import { Stack } from "@mui/material";
import useResponsive from "src/hooks/useResponsive";

import ErrorMessage from "./ErrorMessage";
import ImportingMessage from "./ImportingMessage";
import { usePendingStatus } from "./useGetTransfersData";

// ----------------------------------------------------------------------

export default function ImportingStep() {
	const { status } = usePendingStatus();
	const isMobile = useResponsive("down", "sm");
	const isDownMd = useResponsive("down", "md");

	return (
		<Stack
			sx={{ alignItems: "center" }}
			width={isDownMd ? "auto" : 800}
			height={isMobile ? "auto" : 500}
		>
			{status !== "ERRORED" && <ImportingMessage />}
			{status === "ERRORED" && <ErrorMessage />}
		</Stack>
	);
}
